/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingPersistenceKey {
  static readonly HIDDEN_COLUMNS = 'time-recording/persistence/hidden-columns';
}
